module.exports = __webpack_public_path__ + "assets/plus-aa33caa43ea85f6c3956b8a65508f829.svg";